// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from './http'
import wx from 'weixin-js-sdk'


import filters from './util/filters'
import 'lib-flexible/flexible.js'
import animated from 'animate.css'

// 引用normalize.css
import 'normalize.css'
Vue.use(animated)


Object.keys(filters).forEach(key => Vue.filter(key, filters[key]))
Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.prototype.wx = wx

/* eslint-disable no-new */
new Vue({
  el: '#app',
  axios,
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js